import {RepoIcon, TriangleDownIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

export const RepositoryPickerPlaceholder = () => (
  <Button leadingVisual={RepoIcon} trailingVisual={TriangleDownIcon} disabled>
    Select repository
  </Button>
)
